export enum DataTableType {
    TimeSeries = 'timeSeries',
    Benchmark = 'benchmark'
}
